<template>
  <div class="ui stackable grid">
    <div class="flex-center">
      <div id="firebaseui-auth-container"></div>
      <div class="ui form" v-if="user">
        <div class="field">
          You are already logged in.
        </div>
        <div class="field">
          <div class="ui input">
            <button class="ui button" @click="logout">Logout</button>
          </div>
        </div>
      </div>
    </div>
    <div id="loader" v-if="!user" class="ui active dimmer">
      <div class="ui text loader">Loading</div>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase'
import * as firebaseui from "firebaseui"
const _initAuthUI = (authui) => {
  if (!authui) {
    var uiConfig = {
      signInFlow: 'popup',
      signInSuccessUrl: '/welcome',
      callbacks: {
        uiShown: function () {
          document.getElementById('loader').style.display = 'none'
        }
      },
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
      ]
    }
    authui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
  }
  authui.start('#firebaseui-auth-container', uiConfig)
  return authui
}
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      authui: false
    }
  },
  computed: {
      ...mapGetters({
        user: 'getUser'
      }),
  },
  mounted () {
    if (!this.user) {
      this.authui = _initAuthUI(this.authui)
    }
  },
  methods: {
    logout: function () {
      this.$store.commit('logout')
    }
  }
}
</script>

<style scoped>
 .flex-center {
   max-width: 300px;
   margin: 30px auto 0;
 }
</style>